import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import translations from '../locales';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const I18nContext = createContext({ t: (k) => k, lang: 'en', setLang: () => {} });

export const useI18n = () => useContext(I18nContext);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('ib_lang') || 'en');

  // Auto-detect language from visitor IP on first visit
  useEffect(() => {
    if (localStorage.getItem('ib_lang')) return; // already chosen
    let cancelled = false;
    fetch(`${API_URL}/api/geo/detect-language`)
      .then(r => r.json())
      .then(data => {
        if (cancelled) return;
        const code = data?.lang;
        if (code && translations[code]) {
          localStorage.setItem('ib_lang', code);
          setLang(code);
        }
      })
      .catch(() => {}); // fallback stays 'en'
    return () => { cancelled = true; };
  }, []);

  const setLanguage = useCallback((l) => {
    const code = l?.toLowerCase().slice(0, 2) || 'en';
    const resolved = translations[code] ? code : 'en';
    localStorage.setItem('ib_lang', resolved);
    setLang(resolved);
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ t, lang, setLang: setLanguage }}>
      {children}
    </I18nContext.Provider>
  );
}
